export default "__VITE_ASSET__OgQb9kgC__"